/* Copyright Information: Created by BuyGroup */
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Container,
  CardHeader,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/common/breadcrumb";
import { Formik, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import validationSchema from "./GroupValidationSchema";
import { productList } from "../services/ProductServices";
import { getInfluencersForProducts } from "../services/InfluencerServices";
import { groupDetail, editGroup, deleteGroup } from "../services/GroupServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import trimObj from "../components/common/TrimData";
import DeleteQuantity from "./DeleteQuantity";
import { setMinutes, setHours, setSeconds } from "date-fns";
import CreatableSelect from "react-select/creatable";

toast.configure();

const isDiscountGreaterThanPrice = (levels, price) => {
  if (levels.length > 0) {
    return levels.some(
      (level) => parseFloat(level.discount_percent) > parseFloat(price)
    );
  }
  return false;
};

const readOnlyGroupFields = [
  "description",
  "category",
  "status",
  "supplier_name",
  "productImage",
  "product_name",
  "number_of_participants",
  "category_id",
  "quantity_booked",
  "discounted_price",
  "is_amazon_product",
  "current_product_price",
  "ordersInGroup",
  "amazon_order_placement",
];

const removeReadOnlyGroupFields = (groupData) => {
  const sanitizedData = { ...groupData };

  readOnlyGroupFields.forEach((field) => {
    delete sanitizedData[field];
  });

  return sanitizedData;
};

const EditGroup = (props) => {
  const [isLoading, setLoading] = useState(false);

  /* const "isDisable" responsible for update button disable and able  */
  const [isDisable, setDisable] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  /*  cosnt "selectedProduct" store selected product*/
  const [selectedProduct, setProduct] = useState("");

  const [discountErrorMessage, setDiscountErrorMessage] = useState(""); // range error message

  /* const "levels" store all level of group */
  const [levels, setLevels] = React.useState([]); //levels array

  const [discountPercent, setDiscountPercent] = useState(""); //discount percentage

  /* const "quantityLevel" store qunatity level */
  const [quantityLevel, setQuantityLevel] = useState("");

  const [levelsErrorMessage, setLevelsErrorMessage] = useState("");

  const [lastRange, setLastRange] = useState({
    quantity_level: "",
    discount_percent: "",
  });

  const [zipinputValue, setZipInputValue] = useState("");
  const [zipCodeValue, setZipCodeValue] = useState([]);

  const [initialValues, setInitialValues] = useState({
    offer_name: "",
    minimum_quantity: "",
    start_date: null,
    end_date: null,
    product_id: "",
    levels: [{ quantity: "", discount_percent: "" }],
    price: "",
    zip_code: "",
    buy_group_shipping_allow: "",
    influencers: [],
    region: "Nationwide",
    group_type: "Public",
    include_platform_fee: false,
  });
  /* const "productOptions" store product list  */
  const [productOptions, setProductOptions] = useState([]);
  const [influencerOptions, setInfluencerOptions] = useState([]);
  const [selectedInfluencers, setSelectedInfluencers] = useState([]);

  /*  const "shippingLevel" store shipping range of group*/
  const [shippingLevel, setShippingLevel] = useState([]);

  /* cosnt "isDisableButton "  disable the button */
  const [isDisableButton, setIsDisableButton] = useState(false);

  /* const "showDeleteAlert" responsible for delete group modal open and close */
  const [showDeleteAlert, setshowDeleteAlert] = useState(false);

  /* const "checkedValue" store checkbox value  */
  const [checkedValue, setcheckedValue] = useState(false);

  /*const "deleteRangeModal" responsible for open delete range modal   */
  const [deleteRangeModal, setDeleteRangeModal] = useState(false);

  /* const "deleteRangeId" id Of range that we want to delete */
  const [deleteRangeId, setDeleteRangeId] = useState();

  /* const "groupStartDate" store start date of Group*/
  const [groupStartDate, setgroupStarteDate] = useState(null);

  /* const "groupEndDate" store Max date of Group*/
  const [groupEndDate, setgroupEndDate] = useState(null);

  /* const "disableEndDate" responsible for disable End Date*/
  const [disableEndDate, setdisableEndDate] = useState(false);

  /* const "hideTimeChange" responsible for  hide time change input for end date */
  const [hideTimeChange, sethideTimeChange] = useState(true);

  /* const taken for the status value of Group */
  const [groupStatus, setGroupStatus] = useState("");

  const [checkedValuePlatformFee, setCheckedValuePlatformFee] = useState(false);

  // console.log("date",new Date(
  //   props.start_date.getFullYear(),
  //   props.start_date.getMonth(),
  //   props.start_date.getDate() + 6===props.end_date
  // ))

  // get zip code value
  const getZipValue = (newValue, setFieldValue) => {
    console.log("newValue", newValue);
    setZipInputValue(newValue);
    console.log("zip_code", zipCodeValue);
  };

  const createOption = (label) => ({
    label,
    value: label,
  });
  //Zip code key down function
  const handleKeyDown = (event, setFieldValue) => {
    if (!zipinputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        const newZipCodeValue = [...zipCodeValue, createOption(zipinputValue)];
        setZipCodeValue(newZipCodeValue);
        setFieldValue("zip_code", newZipCodeValue);
        setZipInputValue("");
        event.preventDefault();
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

  //this function is used for product list dropdown in create group
  const getProductList = () => {
    setLoading(true);
    const data = {
      supplier_id: null,
      category_id: null,
      sub_category_id: null,
    };
    productList(data)
      .then((response) => {
        if (response.status === 200) {
          let productList = [{ label: "Select Product", value: "" }];
          //here we are creating option for s=product select
          response.data.map((product) => {
            productList.push({
              label: product.product_name,
              value: product.product_id,
            });
          });
          setProductOptions(productList);
          getGroupDetails(productList);
        }
      })

      .catch((error) => {
        setLoading(false);
      });
  };
  // fetch influencers for a given product id (returns promise of options)
  const fetchInfluencersForProduct = (productId) => {
    if (!productId) {
      setInfluencerOptions([]);
      return Promise.resolve([]);
    }
    return getInfluencersForProducts(productId)
      .then((res) => {
        const data = res?.data || res;
        if (Array.isArray(data)) {
          const options = data.map((p) => ({
            value: p.id,
            label: p.name,
          }));
          setInfluencerOptions(options);
          return options;
        } else {
          setInfluencerOptions([]);
          return [];
        }
      })
      .catch((err) => {
        console.error("Error fetching influencers for product:", err);
        setInfluencerOptions([]);
        return [];
      });
  };
  /* This Function  will give group detail of respective group Id*/
  const getGroupDetails = (productList) => {
    groupDetail(props.match.params.id)
      .then((response) => {
        if (response.status === 200) {
          let responseValues = response.data;
          setGroupStatus(response.data.status);
          responseValues.price = responseValues.price.replace("$", "");
          if (responseValues.group_type === "Private") {
            responseValues.region = "Zipcodes";
          }

          let selectedProduct = productList.find(
            (product) => product.value === response.data.product_id
          );

          const selectedStartDate = new Date(responseValues.start_date);
          if (selectedStartDate !== null) {
            let groupMaxDate = new Date(
              selectedStartDate.getFullYear(),
              selectedStartDate.getMonth(),
              selectedStartDate.getDate() + 6
            );
            setgroupStarteDate(selectedStartDate);
            console.log(
              "groupMaxDate",
              moment(groupMaxDate).format("MM-DD-YYYY")
            );
            console.log(
              "responseValues.end_date",
              moment(new Date(responseValues.end_date)).format("MM-DD-YYYY")
            );
            console.log();
            if (
              moment(groupMaxDate).format("MM-DD-YYYY") ===
              moment(new Date(responseValues.end_date)).format("MM-DD-YYYY")
            ) {
              sethideTimeChange(false);
            }
            setgroupEndDate(groupMaxDate);
            setdisableEndDate(false);
          } else {
            setdisableEndDate(true);
            setgroupEndDate(null);
            setgroupStarteDate(null);
          }

          const zipcode = responseValues.zip_code
            ? responseValues.zip_code.split(",").filter(Boolean)
            : [];
          console.log("zipcode", zipcode);
          const zipobject = zipcode.map((data) => {
            return {
              label: data,
              value: data,
            };
          });
          setZipCodeValue(zipobject);
          responseValues.zip_code = zipobject;
          console.log("zipobject", zipobject);
          responseValues.start_date = moment(responseValues.start_date);
          responseValues.end_date = moment(responseValues.end_date);

          setLevels(response.data.levels);
          setcheckedValue(response.data.buy_group_shipping_allow);
          setCheckedValuePlatformFee(response.data.include_platform_fee);

          if (response.data.shipping_level.length === 0) {
            let shippingOptions = response.data.levels.map((level) => {
              return {
                quantity_level: level.quantity_level,
                shipping_price: "0",
              };
            });
            setShippingLevel(shippingOptions);
          } else {
            setShippingLevel(response.data.shipping_level);
          }
          if (response.data.levels.length > 0) {
            setLastRange(response.data.levels[response.data.levels.length - 1]);
          }
          setProduct(selectedProduct);
          setInitialValues(removeReadOnlyGroupFields(responseValues));
          // fetch influencer options for this product and preselect assigned influencers if any
          fetchInfluencersForProduct(responseValues.product_id).then((options) => {
            if (responseValues.influencers && Array.isArray(responseValues.influencers)) {
              const selected = options.filter((opt) =>
                responseValues.influencers.includes(opt.value) ||
                responseValues.influencers.some((p) => p.product_id === opt.value || p.id === opt.value)
              );
              setSelectedInfluencers(selected);
            } else {
              // if responseValues provides influencer ids directly
              if (Array.isArray(responseValues.influencer_ids)) {
                const selected = options.filter((opt) =>
                  responseValues.influencer_ids.includes(opt.value)
                );
                setSelectedInfluencers(selected);
              }
            }
          });

          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  // this fuction is used to edit group details
  const editGroupFunction = (groupData) => {
    groupData = removeReadOnlyGroupFields(groupData);
    // delete groupData["shipping_cost"];
    if (groupData.buy_group_shipping_allow === true) {
      groupData.buy_group_shipping_allow = JSON.stringify(
        groupData.buy_group_shipping_allow
      );
      delete groupData["shipping_level"];
    }

    if (groupData.buy_group_shipping_allow === false) {
      groupData.buy_group_shipping_allow = JSON.stringify(
        groupData.buy_group_shipping_allow
      );
    }

    if (typeof groupData.minimum_quantity === "string") {
      groupData.minimum_quantity = parseInt(groupData.minimum_quantity);
    }
    if (typeof groupData.price === "string") {
      groupData.price = parseFloat(groupData.price);
    }
    setDisable(true);
    editGroup(groupData)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          setDisable(false);
          props.history.push(`/app/groups/view/${groupData.id}`);
        }
      })
      .catch((error) => {
        setDisable(false);
        setErrorMessage(error.data.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      });
  };

  // this funciton used in status change dropdown takes argument as {label:'',value:''}
  const handleChangeProduct = (selectedOption, setFieldValue) => {
    setProduct(selectedOption);
    setFieldValue("product_id", selectedOption.value);
    // fetch influencer options for selected product and clear previous selection
    setSelectedInfluencers([]);
    setFieldValue("influencers", []);
    if (selectedOption && selectedOption.value) {
      fetchInfluencersForProduct(selectedOption.value);
    } else {
      setInfluencerOptions([]);
    }
  };

  const handleChangeGroupType = (groupType, setFieldValue) => {
    setFieldValue("group_type", groupType);
    if (groupType === "Private") {
      setFieldValue("region", "Zipcodes");
    }
  };

  // discount change custom function logic and condition of discount
  const handleChangeDiscount = (event, key) => {
    //check value is number
    if (!isNaN(event.target.value)) {
      setDiscountPercent(event.target.value);
    } else {
      event.target.value = "";
      setDiscountErrorMessage("Please Enter Numeric Value");
      setDiscountPercent("");
      setTimeout(() => {
        setDiscountErrorMessage("");
      }, 3000);
    }
  };
  // quantity change custom function
  const handleChangeQuantity = (event, key) => {
    if (!isNaN(event.target.value)) {
      //whole number regx
      var rx = new RegExp(/^\d+$/);
      if (!rx.test(event.target.value)) {
        event.target.value = "";
        setDiscountErrorMessage("quantity can not be in decimal");
        setQuantityLevel("");
        setTimeout(() => {
          setDiscountErrorMessage("");
        }, 3000);
      }
      setQuantityLevel(event.target.value);
    } else {
      event.target.value = "";
      setDiscountErrorMessage("Please Enter Numeric Value");
      setQuantityLevel("");
      setTimeout(() => {
        setDiscountErrorMessage("");
      }, 3000);
    }
  };
  // add quantity and shipping range funciton
  const addQuantityrange = () => {
    let rangeObject = {};
    let shippingobj = {};
    if (levels.length === 0) {
      rangeObject["quantity_level"] = quantityLevel;
      rangeObject["discount_percent"] = discountPercent;
      levels.push(rangeObject);
      setLevels(levels);

      shippingobj["quantity_level"] = quantityLevel;
      shippingobj["shipping_price"] = "0";
      shippingLevel.push(shippingobj);
      setShippingLevel(shippingLevel);

      setLastRange(rangeObject);
      setQuantityLevel("");
      setDiscountPercent("");
    } else {
      rangeObject["quantity_level"] = quantityLevel;
      rangeObject["discount_percent"] = discountPercent;
      levels.push(rangeObject);
      setLevels(levels);

      shippingobj["quantity_level"] = quantityLevel;
      shippingobj["shipping_price"] = "0";
      shippingLevel.push(shippingobj);
      setShippingLevel(shippingLevel);

      setLastRange(rangeObject);
      setQuantityLevel("");
      setDiscountPercent("");
    }
  };

  const handleBlurQuantity = (event) => {
    if (levels.length > 0) {
      if (
        parseInt(lastRange["quantity_level"], 10) <
        parseInt(event.target.value, 10)
      ) {
      } else {
        event.target.value = "";
        setQuantityLevel("");
        setLevelsErrorMessage(
          `Please  enter quantity value greater than ${lastRange["quantity_level"]} `
        );
        setTimeout(() => {
          setLevelsErrorMessage("");
        }, 3000);
      }
    }
  };
  const handleBlurDiscount = (event) => {
    var rx = new RegExp(/^\d+(\.\d{1,2})?$/);
    if (rx.test(event.target.value)) {
      if (levels.length > 0) {
        if (
          parseFloat(lastRange["discount_percent"]) <
          parseFloat(event.target.value)
        ) {
        } else {
          event.target.value = "";
          setDiscountPercent("");
          setLevelsErrorMessage(
            `Please  enter discount value greater than ${lastRange["discount_percent"]} `
          );
          setTimeout(() => {
            setLevelsErrorMessage("");
          }, 3000);
        }
      }
    } else {
      event.target.value = "";
      setDiscountPercent("");
      setLevelsErrorMessage(
        ` discount must have 2 digits after decimal or less`
      );
      setTimeout(() => {
        setLevelsErrorMessage("");
      }, 3000);
    }
  };

  const actionFormatter = (cell, row, rowIndex) => (
    <div>
      <span
        className={groupStatus !== "Active" ? "inline-block pointer-cursor" : "inline-block"}
        onClick={(e) => {
          if (groupStatus !== "Active") {
            handleDeleteRange(e, rowIndex)
          }
        }
        }
      >
        <i
          className="fa fa-trash"
          style={{
            width: 35,
            fontSize: 20,
            paddingLeft: 11,

            color: "#e4566e",
          }}
        ></i>
      </span>
    </div>
  );

  // this function remove group and call api s
  const removeGroup = () => {
    setIsDisableButton(true);
    deleteGroup(props.match.params.id)
      .then((response) => {
        if (response.status === 200) {
          setIsDisableButton(false);
          setshowDeleteAlert(false);

          toast.success(response.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          props.history.push("/app/groups");
        }
      })
      .catch((error) => {
        setIsDisableButton(false);
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  const onshowDeleteAlert = () => {
    setshowDeleteAlert(!showDeleteAlert);
  };

  /* This Function handle checkbox  */
  const handleCheckbox = (e, setFieldValue) => {
    const newcheckedvalue = JSON.parse(e.target.value);
    setcheckedValue(!newcheckedvalue);
    setFieldValue("buy_group_shipping_allow", !newcheckedvalue);
  };

  const handleChangeInfluencers = (selected, setFieldValue) => {
    setSelectedInfluencers(selected || []);
    const values = (selected || []).map((s) => s.value);
    setFieldValue("influencers", values);
  };

  /* This Function will handle shipping cost */

  const handleShippingCost = (evt, index) => {
    const { value } = evt.target;
    const newItems = shippingLevel.map((item, index2) => {
      if (index2 !== index) {
        return { ...item };
      }
      return { quantity_level: item.quantity_level, shipping_price: value };
    });
    setShippingLevel(newItems);
  };

  const quantityFormatter = (cell, row, rowIndex) => (
    <div>
      <span>
        {rowIndex === 0
          ? 1 + " - " + cell
          : parseInt(levels[rowIndex - 1].quantity_level) + 1 + " - " + cell}
      </span>
    </div>
  );

  //    columns for bootstrap table
  const columns = [
    {
      dataField: "quantity_level",
      text: "Quantity",
      headerAlign: "right",
      align: "right",
      formatter: quantityFormatter,
    },
    {
      dataField: "discount_percent",
      text: "Price",
      headerAlign: "right",
      align: "right",
      formatter: (cell, row) => {
        return (
          <div className="category_name no-next-line">
            <span> {cell && "$ " + cell}</span>
          </div>
        );
      },
    },
    {
      dataField: "Action",
      text: "Action",
      headerAlign: "center",
      align: "center",
      formatter: actionFormatter,
    },
  ];

  /* This Function remove quantity of rowIndex=index */

  const removeQuantity = (rowIndex) => {
    levels.length = rowIndex;
    setLevels(levels);
    shippingLevel.length = rowIndex;
    setShippingLevel(shippingLevel);
    setDeleteRangeModal(false);
    if (rowIndex > 0) {
      setLastRange(levels[rowIndex - 1]);
    }

    if (levels.length > 0) {
      setDiscountPercent("");
    } else {
      setDiscountPercent("0");
    }
  };

  /* This Function handle quantity range open delete modal*/
  const handleDeleteRange = (e, rowIndex) => {
    setDeleteRangeModal(true);
    setDeleteRangeId(rowIndex);
  };

  /** This Function will handle group start date
  @param selectedStartDate start date
 */

  const handleGroupStartDate = (selectedStartDate, setFieldValue) => {
    if (selectedStartDate !== null) {
      let groupMaxDate = new Date(
        selectedStartDate.getFullYear(),
        selectedStartDate.getMonth(),
        selectedStartDate.getDate() + 6
      );
      setgroupStarteDate(selectedStartDate);
      setgroupEndDate(groupMaxDate);
      setdisableEndDate(false);
    } else {
      setdisableEndDate(true);
      setgroupEndDate(null);
      setgroupStarteDate(null);
    }
    setFieldValue("start_date", selectedStartDate);
    setFieldValue("end_date", null);
  };
  //current Date
  const currentDate = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(currentDate.getDate());

  /**
   * This function will handle group end date
   * @param SelectedEndDate end date
   */
  const handleGroupEndDate = (SelectedEndDate, setFieldValue) => {
    if (SelectedEndDate !== null && groupEndDate !== null) {
      if (SelectedEndDate.getDate() === groupEndDate.getDate()) {
        sethideTimeChange(false);
        if (
          moment(SelectedEndDate).format("HH:mm") >
          moment(groupStartDate).format("HH:mm")
        ) {
          SelectedEndDate.setHours(0, 0, 0, 0);
        }
      } else {
        sethideTimeChange(true);
      }
    }
    setFieldValue("end_date", SelectedEndDate);
  };

  const handleCheckboxPlatformFee = (e, setFieldValue) => {
    console.log("e.target.value", e.target.value);
    const newcheckedvalue = JSON.parse(e.target.value);
    console.log("newcheckedvalue", newcheckedvalue);
    setCheckedValuePlatformFee(!newcheckedvalue);
    setFieldValue("include_platform_fee", !newcheckedvalue);
  };

  return (
    <>
      <Breadcrumbs
        title="Edit BuyGroup"
        parent="BuyGroup"
        subtitle="BuyGroup Admin Panel"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6 ">
                    <h5>Edit BuyGroup</h5>
                  </div>
                  {groupStatus == "Active" && initialValues.quantity_booked != 0 ? (
                    ""
                  ) : (
                    <div className="col-md-6 text-right">
                      <Button
                        type="button"
                        color="secondary"
                        data-toggle="modal"
                        onClick={onshowDeleteAlert}
                        disabled={isLoading}
                      >
                        <i className="fa fa-trash mr-2"></i>
                        Delete
                      </Button>
                    </div>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                {isLoading ? (
                  <div className="custom-loader">
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={(values, actions) => {
                      let newValues = { ...values };
                      if (newValues.group_type === "Private") {
                        newValues.region = "Zipcodes";
                      }
                      if (Array.isArray(newValues.zip_code)) {
                        let zipcodeArray = newValues?.zip_code?.map(
                          (a) => a.value
                        );
                        const ZipResult = zipcodeArray.toString();
                        newValues.zip_code = ZipResult;
                      }

                      if (levels.length === 0 || shippingLevel.length === 0) {
                        setLevelsErrorMessage(
                          "Please Enter range and discount"
                        );
                        setTimeout(() => {
                          setLevelsErrorMessage("");
                        }, 3000);
                      } else {
                        newValues.levels = levels;

                        if (checkedValue === false) {
                          newValues.shipping_level = shippingLevel;
                        }
                        newValues = trimObj(newValues);
                        newValues.start_date = values.start_date;
                        newValues.end_date = values.end_date;

                        if (
                          isDiscountGreaterThanPrice(levels, newValues.price)
                        ) {
                          console.log(
                            "if discount is greater than product price"
                          );
                          setErrorMessage(
                            "Discount cannot be greater than price"
                          );
                          setTimeout(() => setErrorMessage(""), 3000);
                        } else {
                          console.log(
                            "else discount is not greater than product price"
                          );
                          editGroupFunction(newValues);
                        }
                      }
                    }}
                    validationSchema={validationSchema}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      resetForm,
                      setFieldValue,
                    }) => (
                      <form
                        className="needs-validation add-product-form"
                        onSubmit={handleSubmit}
                      >
                        {errorMessage !== undefined && errorMessage !== "" ? (
                          <p className="alert alert-danger">{errorMessage}</p>
                        ) : (
                          ""
                        )}

                        <Row className="product-adding">
                          <Col xl="12">
                            <div className="form form-label-center">
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Group Name
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`offer_name`}
                                    type="text"
                                    placeholder="Group Name"
                                    onChange={handleChange}
                                    value={values.offer_name}
                                    onBlur={handleBlur}
                                  // disabled={groupStatus == "Active"}
                                  />
                                  <ErrorMessage name={`offer_name`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Select Product
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Select
                                    name="product_id"
                                    className="zIndexIncrease suppliers_dropdown"
                                    value={selectedProduct}
                                    isDisabled={groupStatus == "Active"}
                                    onChange={(selectedOption) => {
                                      handleChangeProduct(
                                        selectedOption,
                                        setFieldValue
                                      );
                                    }}
                                    options={productOptions}
                                    placeholder="Select Product"
                                  />

                                  <ErrorMessage name="product_id">
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              {influencerOptions && influencerOptions.length > 0 && (
                                <FormGroup className="form-group mb-3 row">
                                  <Label className="col-xl-3 col-sm-3 mb-0">
                                    Select Influencers
                                  </Label>
                                  <div className="col-xl-9 col-sm-9">
                                    <Select
                                      name="influencers"
                                      isMulti
                                      className="zIndexIncrease vendors_dropdown"
                                      value={selectedInfluencers}
                                      onChange={(selected) =>
                                        handleChangeInfluencers(selected, setFieldValue)
                                      }
                                      options={influencerOptions}
                                      placeholder="Select Influencers"
                                      isDisabled={groupStatus == "Active"}
                                    />
                                    <ErrorMessage name="influencers">
                                      {(msg) => (
                                        <div className="input-feedback">{msg}</div>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </FormGroup>
                              )}
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Minimum Quantity
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`minimum_quantity`}
                                    type="text"
                                    placeholder="minimum Quantity"
                                    value={values.minimum_quantity}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={groupStatus == "Active"}
                                  />
                                  <ErrorMessage name={`minimum_quantity`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Selling Price
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`price`}
                                    type="text"
                                    placeholder="Selling Price"
                                    value={values.price}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={groupStatus == "Active"}
                                  />
                                  <ErrorMessage name={`price`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Visibility
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <FormGroup className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="group_type"
                                        value="Public"
                                        checked={values.group_type === "Public"}
                                        onChange={() =>
                                          handleChangeGroupType(
                                            "Public",
                                            setFieldValue
                                          )
                                        }
                                        disabled={groupStatus == "Active"}
                                      />
                                      Public
                                    </Label>
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="group_type"
                                        value="Private"
                                        checked={values.group_type === "Private"}
                                        onChange={() =>
                                          handleChangeGroupType(
                                            "Private",
                                            setFieldValue
                                          )
                                        }
                                        disabled={groupStatus == "Active"}
                                      />
                                      Private
                                    </Label>
                                  </FormGroup>
                                </div>
                              </FormGroup>

                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Region
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <FormGroup className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                    {values.group_type !== "Private" && (
                                      <Label className="d-block mb-0">
                                        <Input
                                          className="radio_animated"
                                          type="radio"
                                          name="region"
                                          value="Nationwide"
                                          checked={
                                            values.region === "Nationwide"
                                          }
                                          onChange={() => {
                                            setFieldValue(
                                              "region",
                                              "Nationwide"
                                            );
                                            setZipCodeValue([]);
                                            setFieldValue("zip_code", []);
                                          }}
                                          disabled={groupStatus == "Active"}
                                        />
                                        Nationwide
                                      </Label>
                                    )}
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="region"
                                        value="Zipcodes"
                                        checked={values.region === "Zipcodes"}
                                        onChange={() =>
                                          setFieldValue("region", "Zipcodes")
                                        }
                                        disabled={groupStatus == "Active"}
                                      />
                                      Zipcodes
                                    </Label>
                                  </FormGroup>
                                </div>
                              </FormGroup>

                              {values.region === "Zipcodes" && (
                                <FormGroup className="form-group mb-3 row">
                                  <Label className="col-xl-3 col-sm-3 mb-0">
                                    Zip Codes
                                  </Label>
                                  <div className="col-xl-9 col-sm-9">
                                    <CreatableSelect
                                      inputValue={zipinputValue}
                                      name="zip_code"
                                      isClearable
                                      isMulti
                                      menuIsOpen={false}
                                      onInputChange={(newValue) => {
                                        getZipValue(newValue, setFieldValue);
                                      }}
                                      onChange={(newValue) => {
                                        const selectedZipCodes =
                                          newValue || [];
                                        setZipCodeValue(selectedZipCodes);
                                        setFieldValue(
                                          "zip_code",
                                          selectedZipCodes
                                        );
                                      }}
                                      onKeyDown={(event) =>
                                        handleKeyDown(event, setFieldValue)
                                      }
                                      placeholder="Type zip code and press enter..."
                                      value={zipCodeValue}
                                      isDisabled={groupStatus == "Active"}
                                    />
                                    <ErrorMessage name={`zip_code`}>
                                      {(msg) => (
                                        <div className="input-feedback">
                                          {msg}
                                        </div>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </FormGroup>
                              )}
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Start Date
                                </Label>
                                <div className="col-xl-9 col-sm-9 full_width_date">
                                  <DatePicker
                                    selected={
                                      values.start_date
                                        ? new Date(values.start_date)
                                        : null
                                    }
                                    onChange={(selectedDate) =>
                                      handleGroupStartDate(
                                        selectedDate,
                                        setFieldValue
                                      )
                                    }
                                    selectsStart
                                    startDate={
                                      values.start_date
                                        ? new Date(values.start_date)
                                        : null
                                    }
                                    endDate={
                                      values.end_date
                                        ? new Date(values.end_date)
                                        : null
                                    }
                                    // showTimeInput
                                    showTimeSelect
                                    timeIntervals={15}
                                    timeInputLabel="Time:"
                                    placeholderText="Start Date"
                                    minDate={currentDate}
                                    dateFormat="MM/dd/yyyy  h:mm aa"
                                    className="form-control"
                                    name="end_date"
                                  // disabled={groupStatus == "Active"}
                                  />
                                  <ErrorMessage name={`start_date`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  End Date
                                </Label>
                                <div className="col-xl-9 col-sm-9 full_width_date">
                                  <DatePicker
                                    selected={
                                      values.end_date
                                        ? new Date(values.end_date)
                                        : null
                                    }
                                    onChange={(selectedDate) =>
                                      handleGroupEndDate(
                                        selectedDate,
                                        setFieldValue
                                      )
                                    }
                                    selectsEnd
                                    disabled={
                                      disableEndDate ? disableEndDate : false
                                    }
                                    startDate={values.start_date}
                                    endDate={values.end_date}
                                    minDate={groupStartDate}
                                    maxDate={groupEndDate}
                                    // showTimeInput={hideTimeChange}
                                    showTimeSelect
                                    timeIntervals={15}
                                    minTime={setHours(
                                      setMinutes(setSeconds(new Date(), 0), 0),
                                      0
                                    )}
                                    maxTime={
                                      hideTimeChange
                                        ? setHours(
                                          setMinutes(
                                            setSeconds(new Date(), 59),
                                            59
                                          ),
                                          23
                                        )
                                        : groupStartDate
                                    }
                                    timeInputLabel="Time:"
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy  h:mm aa"
                                    className="form-control"
                                    name="end_date"
                                  />
                                  <ErrorMessage name="end_date">
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-2 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Add Quantity Range
                                </Label>
                                <Col md="3">
                                  <Input
                                    className="form-control"
                                    type="text"
                                    placeholder=" Range"
                                    name="Quantity"
                                    value={quantityLevel}
                                    onChange={handleChangeQuantity}
                                    onBlur={handleBlurQuantity}
                                  />
                                </Col>

                                <Col md="3">
                                  <Input
                                    className="form-control"
                                    type="text"
                                    name="discount_percent"
                                    placeholder="Price"
                                    value={discountPercent}
                                    onBlur={handleBlurDiscount}
                                    onChange={handleChangeDiscount}
                                    disabled={levels.length > 0 ? false : true}
                                  />
                                  <ErrorMessage name={`discount_percent`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </Col>
                                <Col md="3">
                                  <FormGroup className="form-group">
                                    <Button
                                      type="button"
                                      disabled={
                                        discountPercent !== "" &&
                                          quantityLevel !== ""
                                          ? false
                                          : true
                                      }
                                      onClick={addQuantityrange}
                                    >
                                      Add Quantity+
                                    </Button>
                                  </FormGroup>
                                </Col>
                              </FormGroup>
                              {discountErrorMessage && (
                                <div className="offset-xl-3 offset-sm-4">
                                  <label className="err-msg">
                                    {discountErrorMessage &&
                                      discountErrorMessage}
                                  </label>
                                </div>
                              )}

                              {levelsErrorMessage && (
                                <div className="offset-xl-3 offset-sm-4">
                                  <label className="err-msg">
                                    {levelsErrorMessage && levelsErrorMessage}
                                  </label>
                                </div>
                              )}

                              <FormGroup className="form-group mb-3 row">
                                <div className="offset-xl-3 offset-sm-3 col-md-6">
                                  {levels.length > 0 && (
                                    <BootstrapTable
                                      keyField="id"
                                      key={`levelsTable`}
                                      striped
                                      hover
                                      condensed
                                      bordered={true}
                                      data={levels}
                                      columns={columns}
                                      rowClasses="row-hover"
                                    />
                                  )}
                                </div>
                                {checkedValue == false && levels.length > 0 && (
                                  <div>
                                    <Label
                                      style={{
                                        marginTop: "0px",
                                        padding: "13px 0px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Add Shipping Range ($)
                                    </Label>
                                    <table>
                                      {shippingLevel.map(
                                        (shippinglevel, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                <Input
                                                  className="form-control"
                                                  style={{ maxWidth: "100px" }}
                                                  value={
                                                    shippinglevel.quantity_level
                                                  }
                                                  disabled={groupStatus == "Active"}
                                                  type="hidden"
                                                />
                                              </td>
                                              <td>
                                                <Input
                                                  type="text"
                                                  style={{
                                                    marginTop: "4px",
                                                    marginBottom: "4px",
                                                    maxWidth: "100px",
                                                  }}
                                                  value={
                                                    shippinglevel.shipping_price
                                                  }
                                                  className="form-control"
                                                  onChange={(evt) =>
                                                    handleShippingCost(
                                                      evt,
                                                      index
                                                    )
                                                  }
                                                  disabled={groupStatus == "Active"}
                                                />
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </table>
                                  </div>
                                )}
                              </FormGroup>
                              <FormGroup>
                                <Input
                                  type="checkbox"
                                  name="buy_group_shipping_allow"
                                  value={checkedValue}
                                  checked={checkedValue}
                                  onChange={(e) =>
                                    handleCheckbox(e, setFieldValue)
                                  }
                                />{" "}
                                <label style={{ marginTop: "0px" }}>
                                  Want to use shippo service?
                                </label>
                              </FormGroup>

                              <FormGroup>
                                <Input
                                  type="checkbox"
                                  name="include_platform_fee"
                                  value={checkedValuePlatformFee}
                                  checked={checkedValuePlatformFee}
                                  onChange={(e) =>
                                    handleCheckboxPlatformFee(e, setFieldValue)
                                  }
                                />
                                <label style={{ marginTop: "0" }}>
                                  Want to include platform fee?
                                </label>
                              </FormGroup>

                              {deleteRangeModal && (
                                <DeleteQuantity
                                  deleteRangeModal={deleteRangeModal}
                                  className="form-control"
                                  removeQuantity={removeQuantity}
                                  deleteRangeId={deleteRangeId}
                                  closedDeleteModal={() =>
                                    setDeleteRangeModal(false)
                                  }
                                />
                              )}
                            </div>
                            <div className="offset-xl-3 offset-sm-3">
                              <Button
                                type="submit"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isDisable}
                              >
                                {isDisable ? "Please Wait" : "update"}
                              </Button>
                              <Link to="/app/groups">
                                <Button type="button" color="light">
                                  Cancel
                                </Button>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                  </Formik>
                )}
                <Modal
                  isOpen={showDeleteAlert}
                  style={{ overlay: { opacity: 0.1 } }}
                >
                  <ModalHeader toggle={onshowDeleteAlert}>
                    <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                      Delete Group
                    </h5>
                  </ModalHeader>
                  <ModalBody>
                    <p>Are you sure you want to delete this Group?</p>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="submit"
                      color="primary"
                      onClick={removeGroup}
                      disabled={isDisableButton ? true : false}
                    >
                      {isDisableButton ? "Please Wait..." : "Yes, Delete it!"}
                    </Button>
                    <Button
                      type="button"
                      color="light"
                      onClick={onshowDeleteAlert}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditGroup;
/* Copyright Information: Created by BuyGroup */
